module.exports = __webpack_public_path__ + "static/media/AR-Eid-Al-Fitr-No-Text.d214fd0d.jpg";